// extracted by mini-css-extract-plugin
export default {"loading":"LoaderBounce_loading__eO-XK","bounce":"LoaderBounce_bounce__CO0-a","loading-bounce":"LoaderBounce_loading-bounce__7WfLA"};